const prefix = 'directory.constituent'

export const PERMISSIONS = {
  VIEW_ALL_CONSTITUENTS: prefix + '.view_all_constituents',
  EXPORT_CONSTITUENTS: prefix + '.export_constituents',
}
